import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const List = (props) => {
    return (React.createElement("div", null, props.items.map((item) => {
        return (React.createElement(ListItem, { key: item.key, onClick: () => {
                props.onSelect(item.returnItem);
            } }, item.label));
    })));
};
export default List;
const ListItem = styled.div `
  padding: 0.5em;
  cursor: pointer;
  border-bottom: 1px solid ${THEME.BORDER_STRONG};
  font-weight: normal;

  &:hover {
    background: ${THEME.FILL};
  }
`;
//# sourceMappingURL=List.js.map